import { Box, Button, Grid, Grow, Icon, IconButton, Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { deleteVotes, getVoteResults, updateVoteSettings } from './AdminMenusRequests';
import StarIcon from '@mui/icons-material/Star';
import { blue, orange, pink, red } from '@mui/material/colors';
import ManIcon from '@mui/icons-material/Man';
import WomanIcon from '@mui/icons-material/Woman';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import ForestIcon from '@mui/icons-material/Forest';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfettiExplosion from 'react-confetti-explosion';
import { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import toast from 'react-hot-toast';
import SettingsIcon from '@mui/icons-material/Settings';
import {SmallModal} from '../../CustomModal/SmallModal';
import Swal from 'sweetalert2';
import { deleteGroupCarolVotes, deleteGroupChantVotes } from './JudgeMenusRequests';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
    backgroundColor: blue[800],
    color: theme.palette.common.white,
    fontSize: 20,
    },
    [`&.${tableCellClasses.body}`]: {
    // fontSize: matches?10:13,
    },
}));
const StyledTableCellFemale = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
    backgroundColor: pink[400],
    color: theme.palette.common.white,
    // fontSize: matches?12:15,
    fontSize: 20,

    },
    [`&.${tableCellClasses.body}`]: {
    // fontSize: matches?10:13,
    },
}));

export const Voting = () => {
    const [isExploding, setIsExploding] = useState(false);
    const [maleResults,setMaleResults] = useState([])
    const [femaleResults,setFemaleResults] = useState([])
    const [starResults,setStarResults] = useState([])
    const [chantResults,setChantResults] = useState([])
    const [carolResults,setCarolResults] = useState([])
    const [loadingMaleResults,setLoadingMaleResults] = useState(true)
    const [loadingFemaleResults,setLoadingFemaleResults] = useState(true)
    const [loadingStarResults,setLoadingStarResults] = useState(true)
    const [loadingChantResults,setLoadingChantResults] = useState(true)
    const [loadingCarolResults,setLoadingCarolResults] = useState(true)
    const [loadingResults,setLoadingResults] = useState(true)
    const [isStarted,setIstarted] = useState(false)
    const [showMaleCatResults,setShowMaleCatResults] = useState(false)
    const [showFemaleCatResults,setShowFemaleCatResults] = useState(false)
    const [showStarCatResults,setShowStarCatResults] = useState(false)
    const [showChantCatResults,setShowChantCatResults] = useState(false)
    const [showCarolCatResults,setShowCarolCatResults] = useState(false)
    useEffect(()=>{
        _init();
    },[])
    const handleReload = () => {
        _init();
    }
    const _init = async () => {
        const res = await getVoteResults()
        setMaleResults(res.data.male_results)
        setFemaleResults(res.data.female_results)
        setStarResults(res.data.star_results)
        setChantResults(res.data.chant_results)
        setCarolResults(res.data.carol_results)
        setIstarted(res.data.is_started === 0 ? false:true)
        // setTimeout(()=>{
        //     setLoadingResults(false)
        //     if(res.data.male_results.length>0 || res.data.female_results.length>0){
        //         setIsExploding(true)
        //     }
        // },[2000])
        setLoadingResults(false)
        // if(res.data.male_results.length>0 || res.data.female_results.length>0){
        //     setIsExploding(true)
        // }
    }
    const handleUpdateStarted = async () =>{
        setIstarted(prev=>!prev)

        const toastId = toast.loading('Updating Status');
        const res = await updateVoteSettings({started:!isStarted})
        if(res.data.status === 200){
            toast.success(res.data.message,{
                id:toastId
            })
        }else{
            toast.success(res.data.message,{
                id:toastId
            })
        }
    }
    const [openSettingsModal,setOpenSettingsModal] = useState(false)
    const [openPassword,setOpenPassword] = useState(false)
    const [password,setPassword] = useState('')
    const handleResetVote = () => {
        Swal.fire({
            icon:'question',
            title:'Confirm deletion of votes?',
            text:'This action cannot be reverted',
            confirmButtonText:'Yes, I confirm deletion!',
            cancelButtonText:'No, Cancel it!',
            showCancelButton:true
        }).then(res=>{
            if(res.isConfirmed){
                setOpenPassword(true);
                Swal.close();
            }
        })
    }
    const handleSubmitPassword = async (e) =>{
        e.preventDefault();
        if(password !== 'DENR_RICTU13'){
            toast.error('Invalid Password')
        }else{
            toast.success('Password Accepted')
            const toastId = toast.loading('Deleting Votes')
            const res = await deleteVotes();

            if(res.data.status === 200){
                setMaleResults(res.data.data.male_results);
                setFemaleResults(res.data.data.female_results);
                setStarResults(res.data.data.star_results);
                setOpenPassword(false)
                toast.success(res.data.status,{
                    id:toastId
                });
            }else{
                toast.error(res.data.status,{
                    id:toastId
                });
            }
        }
    }
    useEffect(()=>{
        if(showMaleCatResults &&maleResults.length>0){
            setIsExploding(true)
        }else{
            setIsExploding(false)
        }
    },[showMaleCatResults])
    useEffect(()=>{
        if(showFemaleCatResults &&femaleResults.length>0){
            setIsExploding(true)
        }else{
            setIsExploding(false)
        }
    },[showFemaleCatResults])
    useEffect(()=>{
        if(showStarCatResults && starResults.length>0){
            setIsExploding(true)
        }else{
            setIsExploding(false)
        }
    },[showStarCatResults])
    useEffect(()=>{
        if(showChantCatResults && chantResults.length>0){
            setIsExploding(true)
        }else{
            setIsExploding(false)
        }
    },[showChantCatResults])
    useEffect(()=>{
        if(showCarolCatResults && carolResults.length>0){
            setIsExploding(true)
        }else{
            setIsExploding(false)
        }
    },[showCarolCatResults])
    const handleMaleCatResults = async () =>{
        setShowMaleCatResults(prev=>!prev)
        if(maleResults.length>0){
            setIsExploding(true)
        }
        setLoadingMaleResults(prev=>!prev)
    }
    const handleFemaleCatResults = async () =>{
        setShowFemaleCatResults(prev=>!prev)
        if(femaleResults.length>0){
            setIsExploding(true)
        }
        setLoadingFemaleResults(prev=>!prev)
    }
    const handleStarCatResults = async () =>{
        setShowStarCatResults(prev=>!prev)
        if(starResults.length>0){
            setIsExploding(true)
        }
        setLoadingStarResults(prev=>!prev)
    }
    const handleChantCatResults = async () =>{
        setShowChantCatResults(prev=>!prev)
        if(femaleResults.length>0){
            setIsExploding(true)
        }
        setLoadingChantResults(prev=>!prev)
    }
    const handleCarolCatResults = async () =>{
        setShowCarolCatResults(prev=>!prev)
        if(carolResults.length>0){
            setIsExploding(true)
        }
        setLoadingCarolResults(prev=>!prev)
    }
    const handleResetGroupChant = ()=>{
        Swal.fire({
            icon:'question',
            title:'Confirm deletion of Group Chant Votes ?',
            text:'This action cannot be reverted',
            confirmButtonText:'Yes, I confirm deletion!',
            cancelButtonText:'No, Cancel it!',
            showCancelButton:true
        }).then(async res=>{
            if(res.isConfirmed){
                const toastId = toast.loading('Deleting Group Chant Votes')
                const res = await deleteGroupChantVotes()
                if(res.data.status === 200){
                    setChantResults(res.data.data.chant_results)
                    toast.success(res.data.message,{
                        id:toastId
                    })
                }else{
                    toast.error(res.data.message,{
                        id:toastId
                    })
                }
            }
        })
    }
    const handleResetGroupCarol = ()=>{
        Swal.fire({
            icon:'question',
            title:'Confirm deletion of Group Chant Votes ?',
            text:'This action cannot be reverted',
            confirmButtonText:'Yes, I confirm deletion!',
            cancelButtonText:'No, Cancel it!',
            showCancelButton:true

        }).then(async res=>{
            if(res.isConfirmed){
                const toastId = toast.loading('Deleting Group Chant Votes')
                const res = await deleteGroupCarolVotes()
                if(res.data.status === 200){
                    setCarolResults(res.data.data.carol_results)
                    toast.success(res.data.message,{
                        id:toastId
                    })
                }else{
                    toast.error(res.data.message,{
                        id:toastId
                    })
                }
            }
        })
    }
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sx={{display:'flex',justifyContent:'space-around',position: 'fixed', width: '100%',top:' 30%'}}>
                {isExploding && <ConfettiExplosion duration={6000} particleCount={250} />}
                {isExploding && <ConfettiExplosion duration={6000} particleCount={250} />}
                {isExploding && <ConfettiExplosion duration={6000} particleCount={250} />}
            </Grid>
            <Grid item xs={12} sx={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <Box sx={{width:'100%'}}>
                <Typography variant='h4' className='good-timing' sx={{textAlign:'center',color:orange[800],textTransform:'uppercase'}}>Voting Results</Typography>
                </Box>
                <Box sx={{display:'flex',flexDirection:'row'}}>
                    <IconButton onClick={()=>setOpenSettingsModal(true)}>
                        <SettingsIcon/>
                    </IconButton>
                    <IconButton onClick={handleReload} color='info'>
                        <RestartAltIcon/>
                    </IconButton>
                </Box>

            </Grid>
            <Grid item xs={12}>
                <Box sx={{display:'flex',justifyContent:'space-between'}}>
                <Typography variant='h6' sx={{display:'flex',alignItems:'center',mb:1,color:orange[800]}}> <StarIcon fontSize='large' sx={{color:orange[800]}}/> Star of the Night</Typography>
                <FormControlLabel control={<Switch checked={showStarCatResults} onChange={handleStarCatResults} />} label="Show Results" />
                </Box>
                <Grow in>
                    <Paper>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>
                                            <Box sx={{display:'flex',gap:1,alignItems:'center',justifyContent:'center'}}>
                                                <StarIcon sx={{color:orange[500]}}/> Rank
                                            </Box>
                                        </StyledTableCell>
                                        <StyledTableCell align='center' >
                                            Number
                                        </StyledTableCell>
                                        <StyledTableCell align='center' >
                                            Votes Accumulated
                                        </StyledTableCell>
                                        <StyledTableCell align='center' >
                                            Name
                                        </StyledTableCell>
                                        <StyledTableCell align='center' >
                                            Office
                                        </StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        loadingStarResults
                                        ?
                                        <>
                                        <TableRow>
                                            <TableCell colSpan={5}>
                                                <Skeleton variant='rectangular'/>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={5}>
                                                <Skeleton variant='rectangular'/>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={5}>
                                                <Skeleton variant='rectangular'/>
                                            </TableCell>
                                        </TableRow>
                                        </>
                                        :
                                        starResults.map((item)=>
                                            <TableRow key={item.number}>
                                                <TableCell align='center' sx={{fontSize:item.rank ===1?'1.4rem':'auto',fontWeight:item.rank ===1?'bold':'normal',color:item.rank ===1?'red':'black'}}>
                                                    {item.rank}
                                                </TableCell>
                                                <TableCell align='center' sx={{fontSize:item.rank ===1?'1.4rem':'auto',fontWeight:item.rank ===1?'bold':'normal',color:item.rank ===1?'red':'black'}}>
                                                    #{item.number}
                                                </TableCell>
                                                <TableCell align='center' sx={{fontSize:item.rank ===1?'1.4rem':'auto',fontWeight:item.rank ===1?'bold':'normal',color:item.rank ===1?'red':'black'}}>
                                                    {item.total_vote}
                                                </TableCell>
                                                <TableCell align='center' sx={{fontSize:item.rank ===1?'1.4rem':'auto',fontWeight:item.rank ===1?'bold':'normal',color:item.rank ===1?'red':'black'}}>
                                                    {item.name}
                                                </TableCell>
                                                <TableCell align='center' sx={{fontSize:item.rank ===1?'1.4rem':'auto',fontWeight:item.rank ===1?'bold':'normal',color:item.rank ===1?'red':'black'}}>
                                                    {item.office}
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Grow>
            </Grid>
            <Grid item xs={12}>
                <Box sx={{display:'flex',justifyContent:'space-between'}}>
                <Typography variant='h6' sx={{display:'flex',alignItems:'center',mb:1,color:blue[800]}}> <ManIcon fontSize='large' sx={{color:blue[800]}}/> Male Category</Typography>
                <FormControlLabel control={<Switch checked={showMaleCatResults} onChange={handleMaleCatResults} />} label="Show Results" />
                </Box>
                <Grow in>
                    <Paper>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>
                                            <Box sx={{display:'flex',gap:1,alignItems:'center',justifyContent:'center'}}>
                                                <StarIcon sx={{color:orange[500]}}/> Rank
                                            </Box>
                                        </StyledTableCell>
                                        <StyledTableCell align='center' >
                                            Number
                                        </StyledTableCell>
                                        <StyledTableCell align='center' >
                                            Votes Accumulated
                                        </StyledTableCell>
                                        <StyledTableCell align='center' >
                                            Name
                                        </StyledTableCell>
                                        <StyledTableCell align='center' >
                                            Office
                                        </StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        loadingMaleResults
                                        ?
                                        <>
                                        <TableRow>
                                            <TableCell colSpan={5}>
                                                <Skeleton variant='rectangular'/>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={5}>
                                                <Skeleton variant='rectangular'/>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={5}>
                                                <Skeleton variant='rectangular'/>
                                            </TableCell>
                                        </TableRow>
                                        </>
                                        :
                                        maleResults.map((item)=>
                                            <TableRow key={item.number}>
                                                <TableCell align='center' sx={{fontSize:item.rank ===1?'1.4rem':'auto',fontWeight:item.rank ===1?'bold':'normal',color:item.rank ===1?'red':'black'}}>
                                                    {item.rank}
                                                </TableCell>
                                                <TableCell align='center' sx={{fontSize:item.rank ===1?'1.4rem':'auto',fontWeight:item.rank ===1?'bold':'normal',color:item.rank ===1?'red':'black'}}>
                                                    #{item.number}
                                                </TableCell>
                                                <TableCell align='center' sx={{fontSize:item.rank ===1?'1.4rem':'auto',fontWeight:item.rank ===1?'bold':'normal',color:item.rank ===1?'red':'black'}}>
                                                    {item.total_vote}
                                                </TableCell>
                                                <TableCell align='center' sx={{fontSize:item.rank ===1?'1.4rem':'auto',fontWeight:item.rank ===1?'bold':'normal',color:item.rank ===1?'red':'black'}}>
                                                    {item.name}
                                                </TableCell>
                                                <TableCell align='center' sx={{fontSize:item.rank ===1?'1.4rem':'auto',fontWeight:item.rank ===1?'bold':'normal',color:item.rank ===1?'red':'black'}}>
                                                    {item.office}
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Grow>
            </Grid>
            <Grid item xs={12}>
                <Box sx={{display:'flex',justifyContent:'space-between'}}>
                <Typography variant='h6' sx={{display:'flex',alignItems:'center',mb:1,color:pink[400]}}> <WomanIcon fontSize='large' sx={{color:pink[400]}}/> Female Category</Typography>
                <FormControlLabel control={<Switch checked={showFemaleCatResults} onChange={handleFemaleCatResults} />} label="Show Results" />
                </Box>
                <Grow in>
                    <Paper>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCellFemale >
                                            <Box sx={{display:'flex',gap:1,alignItems:'center',justifyContent:'center'}}>
                                                <StarIcon sx={{color:orange[300]}}/> Rank
                                            </Box>
                                        </StyledTableCellFemale>
                                        <StyledTableCellFemale align='center' >
                                            Number
                                        </StyledTableCellFemale>
                                        <StyledTableCellFemale align='center' >
                                            Votes Accumulated
                                        </StyledTableCellFemale>
                                        <StyledTableCellFemale align='center' >
                                            Name
                                        </StyledTableCellFemale>
                                        <StyledTableCellFemale align='center' >
                                            Office
                                        </StyledTableCellFemale>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        loadingFemaleResults
                                        ?
                                        <>
                                        <TableRow>
                                            <TableCell colSpan={5}>
                                                <Skeleton variant='rectangular'/>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={5}>
                                                <Skeleton variant='rectangular'/>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={5}>
                                                <Skeleton variant='rectangular'/>
                                            </TableCell>
                                        </TableRow>
                                        </>
                                        :
                                        femaleResults.map((item)=>
                                            <TableRow key={item.number}>
                                                <TableCell align='center' sx={{fontSize:item.rank ===1?'1.4rem':'auto',fontWeight:item.rank ===1?'bold':'normal',color:item.rank ===1?'red':'black'}}>
                                                    {item.rank}
                                                </TableCell>
                                                <TableCell align='center' sx={{fontSize:item.rank ===1?'1.4rem':'auto',fontWeight:item.rank ===1?'bold':'normal',color:item.rank ===1?'red':'black'}}>
                                                    #{item.number}
                                                </TableCell>
                                                <TableCell align='center' sx={{fontSize:item.rank ===1?'1.4rem':'auto',fontWeight:item.rank ===1?'bold':'normal',color:item.rank ===1?'red':'black'}}>
                                                    {item.total_vote}
                                                </TableCell>
                                                <TableCell align='center' sx={{fontSize:item.rank ===1?'1.4rem':'auto',fontWeight:item.rank ===1?'bold':'normal',color:item.rank ===1?'red':'black'}}>
                                                    {item.name}
                                                </TableCell>
                                                <TableCell align='center' sx={{fontSize:item.rank ===1?'1.4rem':'auto',fontWeight:item.rank ===1?'bold':'normal',color:item.rank ===1?'red':'black'}}>
                                                    {item.office}
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Grow>
            </Grid>
            <Grid item xs={12}>
                <Box sx={{display:'flex',justifyContent:'space-between'}}>
                <Typography variant='h6' sx={{display:'flex',alignItems:'center',mb:1,color:blue[800]}}> Group Chant</Typography>
                <Box>
                    <FormControlLabel control={<Switch checked={showChantCatResults} onChange={handleChantCatResults} />} label="Show Results" />
                    <Tooltip title='Reset Group Chant Votes'>
                    <IconButton color='error' onClick={handleResetGroupChant}>
                        <DeleteIcon/>
                    </IconButton>
                    </Tooltip>
                </Box>
                </Box>
                <Grow in>
                    <Paper>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell >
                                            <Box sx={{display:'flex',gap:1,alignItems:'center',justifyContent:'center'}}>
                                                <StarIcon sx={{color:orange[300]}}/> Rank
                                            </Box>
                                        </StyledTableCell>
                                        <StyledTableCell align='center' >
                                            Votes Accumulated
                                        </StyledTableCell>
                                        <StyledTableCell align='center' >
                                            Group Name
                                        </StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        loadingChantResults
                                        ?
                                        <>
                                        <TableRow>
                                            <TableCell colSpan={5}>
                                                <Skeleton variant='rectangular'/>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={5}>
                                                <Skeleton variant='rectangular'/>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={5}>
                                                <Skeleton variant='rectangular'/>
                                            </TableCell>
                                        </TableRow>
                                        </>
                                        :
                                        chantResults.map((item)=>
                                            <TableRow key={item.number}>
                                                <TableCell align='center' sx={{fontSize:item.rank ===1?'1.4rem':'auto',fontWeight:item.rank ===1?'bold':'normal',color:item.rank ===1?'red':'black'}}>
                                                    {item.rank}
                                                </TableCell>
                                                <TableCell align='center' sx={{fontSize:item.rank ===1?'1.4rem':'auto',fontWeight:item.rank ===1?'bold':'normal',color:item.rank ===1?'red':'black'}}>
                                                    {item.total_vote}
                                                </TableCell>
                                                <TableCell align='center' sx={{fontSize:item.rank ===1?'1.4rem':'auto',fontWeight:item.rank ===1?'bold':'normal',color:item.rank ===1?'red':'black'}}>
                                                    {item.group_name}
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Grow>
            </Grid>
            <Grid item xs={12}>
                <Box sx={{display:'flex',justifyContent:'space-between'}}>
                <Typography variant='h6' sx={{display:'flex',alignItems:'center',mb:1,color:blue[800]}}> Christmas Carol</Typography>
                <Box>
                <FormControlLabel control={<Switch checked={showCarolCatResults} onChange={handleCarolCatResults} />} label="Show Results" />

                <Tooltip title='Reset Group Chant Votes'>
                    <IconButton color='error' onClick={handleResetGroupCarol}>
                        <DeleteIcon/>
                    </IconButton>
                    </Tooltip>
                </Box>
                </Box>
                <Grow in>
                    <Paper>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell >
                                            <Box sx={{display:'flex',gap:1,alignItems:'center',justifyContent:'center'}}>
                                                <StarIcon sx={{color:orange[300]}}/> Rank
                                            </Box>
                                        </StyledTableCell>
                                        <StyledTableCell align='center' >
                                            Votes Accumulated
                                        </StyledTableCell>
                                        <StyledTableCell align='center' >
                                            Group Name
                                        </StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        loadingCarolResults
                                        ?
                                        <>
                                        <TableRow>
                                            <TableCell colSpan={5}>
                                                <Skeleton variant='rectangular'/>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={5}>
                                                <Skeleton variant='rectangular'/>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={5}>
                                                <Skeleton variant='rectangular'/>
                                            </TableCell>
                                        </TableRow>
                                        </>
                                        :
                                        carolResults.map((item)=>
                                            <TableRow key={item.number}>
                                                <TableCell align='center' sx={{fontSize:item.rank ===1?'1.4rem':'auto',fontWeight:item.rank ===1?'bold':'normal',color:item.rank ===1?'red':'black'}}>
                                                    {item.rank}
                                                </TableCell>
                                                <TableCell align='center' sx={{fontSize:item.rank ===1?'1.4rem':'auto',fontWeight:item.rank ===1?'bold':'normal',color:item.rank ===1?'red':'black'}}>
                                                    {item.total_vote}
                                                </TableCell>
                                                <TableCell align='center' sx={{fontSize:item.rank ===1?'1.4rem':'auto',fontWeight:item.rank ===1?'bold':'normal',color:item.rank ===1?'red':'black'}}>
                                                    {item.group_name}
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Grow>
            </Grid>
            <SmallModal open = {openSettingsModal} close = {()=>setOpenSettingsModal(false)} clickOutside={true} title ='Voting Settings'>
                <Box sx={{display:'flex',justifyContent:'space-between'}}>
                    <Button variant='outlined' startIcon={<RestartAltIcon/>} onClick={handleResetVote}>Reset Votes</Button>
                    <FormControlLabel control={<Switch checked={isStarted} onChange={handleUpdateStarted} />} label="Started" />
                </Box>

            </SmallModal>
            <SmallModal open = {openPassword} close = {()=>setOpenPassword(false)} clickOutside={true} title='Admin Password' >
                <form onSubmit={handleSubmitPassword}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <TextField type='password' label='Password' value={password} onChange={(e)=>setPassword(e.target.value)} fullWidth required/>
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant='contained' type='submit'>Proceed</Button>
                        </Grid>
                    </Grid>
                </form>

            </SmallModal>
            {/* <div class="marquee-parent">
                <div class="marquee-child">
                    Congratulations !!!
                </div>
                </div>
            <Grid item xs={12}>
                
            </Grid> */}
        </Grid>
    )
}